import React, { useContext, useEffect, useState } from 'react'
import { IconContext } from 'react-icons'
import {
    FaMousePointer,
    FaTimesCircle,
    FaVectorSquare,
    FaDrawPolygon,
    FaInfoCircle,
    FaLayerGroup,
    FaFilter,
    FaTimes,
    FaRuler,
} from 'react-icons/fa'
import { MdFormatShapes } from 'react-icons/md'

import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import { MapControlContext } from './MapControlContext'
import { DataContext } from './DataContext'
import { AppStateContext } from '../AppStateContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import withConfig from '../../../wrappers/withConfig'
import MeasureSelect from './header-controls/MeasureSelect'
import CollapseButton from '../../../elem/list/CollapseButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'

const MapHeaderControls = ({ config }) => {
    const {
        mapState: { selectedFeatures, mapSelectionIds },
        setMapState,
    } = useContext(AppStateContext)
    const { backgroundColorClass, borderClass, headerIconClass } = useContext(
        PanelStyleContext
    )
    const {
        activeControl,
        activateControl,
        clearControls,
        displayTooltip,
        toggleTooltip,
        displayMapLayers,
        toggleMapLayers,
        pinned,
    } = useContext(MapControlContext)
    const { clearSelectionLayer, saveAsImageMap, data } = useContext(
        DataContext
    )
    const [downloadingImage, setDownloadingImage] = useState(false)
    const { ID_COLUMN } = config

    const controls = [
        {
            icon: FaMousePointer,
            name: 'select',
            tooltip: 'Select Wells by Click',
        },
        {
            icon: FaVectorSquare,
            name: 'boundingBox',
            tooltip: 'Select Wells by Rectangle',
        },
        {
            icon: FaDrawPolygon,
            name: 'polygon',
            tooltip: 'Select Wells by Polygon',
        },
        {
            icon: FaRuler,
            name: 'measure',
            tooltip: 'Measure Distance',
        },
        {
            icon: MdFormatShapes,
            name: 'measureArea',
            tooltip: 'Measure Area',
        },
    ]

    return (
        <div className="panelHeaderControls">
            <div
                id="distanceUnitDiv"
                className={`is-small
                    ${
                        activeControl &&
                        (activeControl === 'measure' ||
                            activeControl === 'measureArea')
                            ? ''
                            : 'is-hidden'
                    }
                `}
            >
                <MeasureSelect control={activeControl} />
            </div>
            <div className="panelHeaderIconWrapper">
                <button
                    disabled={!(selectedFeatures && selectedFeatures.length)}
                    className={`button is-small panelHeaderIconDiv ${borderClass} ${backgroundColorClass} ${headerIconClass} displayIcon`}
                    // data-tip={'Filter by Map Selection'}
                    // data-for={`filterByMapSelection`}
                    onClick={() => {
                        setMapState(prevState => ({
                            ...prevState,
                            mapSelectionIds: selectedFeatures
                                .map(x => x.get(ID_COLUMN))
                                .join(','),
                        }))
                    }}
                >
                    <span className="icon is-small">
                        <IconContext.Provider
                            value={{
                                className: `panelHeaderIcon inactive`,
                            }}
                        >
                            <FaFilter />
                        </IconContext.Provider>
                    </span>
                    <span>Filter by Map Selection</span>
                    {/* <Tooltip id={`filterByMapSelection`} /> */}
                </button>
                <button
                    disabled={
                        mapSelectionIds === null || mapSelectionIds === ''
                    }
                    className={`button is-small panelHeaderIconDiv ${borderClass} ${backgroundColorClass} ${headerIconClass} displayIcon`}
                    // data-tip={'Filter by Map Selection'}
                    // data-for={`filterByMapSelection`}
                    onClick={() => {
                        setMapState(prevState => ({
                            ...prevState,
                            mapSelectionIds: '',
                        }))
                    }}
                >
                    <span className="icon is-small">
                        <IconContext.Provider
                            value={{
                                className: `panelHeaderIcon inactive`,
                            }}
                        >
                            <FaTimes />
                        </IconContext.Provider>
                    </span>
                    <span>Remove Map Filter</span>
                    {/* <Tooltip id={`filterByMapSelection`} /> */}
                </button>
                <div className="controlsGroupedWrapper">
                    {controls.map((control, idx) => {
                        const { name, icon: Icon, tooltip } = control
                        return (
                            <div
                                key={`icon-${idx}`}
                                className={`panelHeaderIconDiv displayIcon ${
                                    activeControl === name
                                        ? 'active'
                                        : 'inactive'
                                }`}
                                data-tip={`${tooltip}`}
                                data-for={`${name}`}
                            >
                                <IconContext.Provider
                                    value={{
                                        className: `panelHeaderIcon ${
                                            activeControl === name
                                                ? 'active'
                                                : 'inactive'
                                        }`,
                                    }}
                                >
                                    <Icon
                                        onClick={() => {
                                            if (activeControl === name) {
                                                clearControls()
                                            } else {
                                                activateControl(name)
                                            }
                                        }}
                                    />
                                </IconContext.Provider>
                                <Tooltip id={name} />
                            </div>
                        )
                    })}
                    <SaveAsImageButton
                        name={'map'}
                        customOnClickAction={() => {
                            saveAsImageMap(setDownloadingImage)
                        }}
                        pending={downloadingImage}
                    />
                </div>
                <div
                    className={`panelHeaderIconDiv displayIcon ${
                        displayTooltip ? 'active' : 'inactive'
                    }`}
                    data-for={`displayTooltip-${displayTooltip}`}
                    data-tip={'Display / Hide Tooltip'}
                >
                    <IconContext.Provider
                        value={{
                            className: `panelHeaderIcon ${
                                displayTooltip ? 'active' : 'inactive'
                            }`,
                        }}
                    >
                        <FaInfoCircle
                            onClick={() => {
                                toggleTooltip(!displayTooltip)
                            }}
                        />
                    </IconContext.Provider>
                    <Tooltip id={`displayTooltip-${displayTooltip}`} />
                </div>
                <div
                    className="panelHeaderIconDiv"
                    data-for={'clearSelection'}
                    data-tip={'Clear Selection'}
                >
                    <IconContext.Provider
                        value={{
                            className: 'mapIcon inactive',
                        }}
                    >
                        <FaTimesCircle
                            onClick={() => {
                                clearControls()
                                clearSelectionLayer()
                            }}
                        />
                    </IconContext.Provider>
                    <Tooltip id={'clearSelection'} />
                </div>
                {!pinned && (
                    <div
                        className="panelHeaderIconDiv"
                        data-for={`display-layers-${displayMapLayers}`}
                        data-tip={'Display / Hide Layers'}
                        id={'displayLayers'}
                    >
                        <FaLayerGroup
                            id={'displayLayers'}
                            className={'panelHeaderIcon'}
                            onClick={() => {
                                toggleMapLayers(!displayMapLayers)
                            }}
                        />
                        <Tooltip id={`display-layers-${displayMapLayers}`} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default withConfig(MapHeaderControls)
